export function getActiveTab() {
  const savedTab = localStorage.getItem("activeTab");
  if (!savedTab) {
    return null;
  }

  try {
    const tab = JSON.parse(savedTab);
    // if (tab.path !== window.location.pathname) {
    //   return null;
    // }
    return tab;
  } catch (error) {
    console.error("Failed to parse activeTab from localStorage:", error);
    return null;
  }
}

export function setActiveTab(tab, route) {
  if (tab && typeof tab === "object" && "id" in tab) {
    try {
      const serializableTab = {
        id: tab.id,
        title: tab.title,
        collection: tab.collection,
        path: route.path
      };
      localStorage.setItem("activeTab", JSON.stringify(serializableTab));
    } catch (error) {
      console.error("Failed to save tab to localStorage:", error);
    }
  } else {
    console.warn("Invalid tab object provided:", tab);
  }
}

export function setDefaultTab() {
  try {
    const serializableTab = {
      id: 0,
      title: "",
      collection: "",
      path: window.location.pathname
    };
    localStorage.setItem("activeTab", JSON.stringify(serializableTab));
    localStorage.setItem('currentPostsFilter', JSON.stringify({ id: 0, label: 'All', activeTab: 0 }));
  } catch (error) {
    console.error("Failed to save tab to localStorage:", error);
  }
}
